module.exports = __webpack_public_path__ + "static/media/ATLASSHORTS-globe-only-blue.a6e4d305.png";